import { combineReducers } from "redux";
import {
    RECEIVE_SERVER_RESPONSE,
    PAGE_SELECTED,
    LOAD_USERDATA,
    BRAND_SELECTED,
    BRANCH_SELECTED,
    LOGOUT,
    CLEAR_NAV_HISTORY,
    STEP_BACK,
    UPDATE_GLOBAL_SEARCH,
    ALERT, LOAD_ACCOUNTS, RELOAD_BRANDS, SET_ACTIVE_ACCOUNT_ID,
    LOAD_PLAN_DATA, LOAD_PLAN_OVERRIDES,
} from "../actions/actionTypes";
import { routerReducer } from "react-router-redux";
import Constants from "../data/constants";
import PermissionManager from "../managers/PermissionManager";
import PlanLimitsManager from "../managers/PlanLimitsManager";
import { getLogInAPIAction } from "../Config";

const globalSearchReducer = (searchWord = "", action) => {
    // console.log("globalSearchReducer " + searchWord)
    if (action.type == UPDATE_GLOBAL_SEARCH) return action.payload;
    return searchWord;
};
const selectedBrandDataReducer = (selectedBrandData = null, action) => {
    if (action.type === LOGOUT) {
        return null;
    }
    if (action.type === BRAND_SELECTED) {
        return action.payload;
    }

    return selectedBrandData;
};

const alertMessageReducer = (message = "", action) => {
    if (action.type === ALERT) {
        // console.log("alert message changed " + action.payload)
        return action.payload;
    }

    return message;
};
const selectedBranchDataReducer = (selectedBranchData = null, action) => {
    // console.log("SFSFSFSFSFS " + JSON.stringify(action.payload))
    if (action.type === LOGOUT) {
        return null;
    }

    if (action.type === BRANCH_SELECTED) {
        return action.payload;
    }

    return selectedBranchData;
};

const selectedPageReducer = (
    selectedPage = { id: "", content: null },
    action,
) => {
    // console.log("selectedPageReducer " + action.type + " " + action.payload)
    if (action.type === LOGOUT) {
        return { id: Constants.LOGIN_PAGE, content: null };
    } else if (action.type === PAGE_SELECTED) {
        // console.log("page selected" + JSON.stringify(action.payload))
        return action.payload;
    }

    return selectedPage;
};

const userdataReducer = (userdata = {}, action) => {
    if (action.type === LOGOUT) {
        return {};
    } else if (action.type === RECEIVE_SERVER_RESPONSE) {
        if (
            action.payload.response.status === "error" &&
            action.payload.response.code === 600
        ) {
            return {};
        }

        const loginAction = getLogInAPIAction();

        if (action.payload.action === loginAction) {
            PermissionManager.userData = action.payload.response.data;
            const encodedString = new Buffer(
                JSON.stringify(action.payload.response.data),
            ).toString("base64");
            localStorage.setItem("userdata", encodedString);

            return action.payload.response.data;
        }
    } else if (action.type === LOAD_USERDATA) {
        if (action.payload !== null) {
            PermissionManager.userData = action.payload;
            return action.payload;
        }
    }

    return userdata;
};
const usertokenReducer = (usertoken = "", action) => {
    // console.log("user token " + usertoken)
    if (usertoken === undefined || usertoken === null) {
        return "";
    }

    if (action.type === LOGOUT) {
        return "";
    } else if (action.type === RECEIVE_SERVER_RESPONSE) {
        if (
            action.payload.response.status === "error" &&
            action.payload.response.code === 600
        ) {
            return "";
        }

        const loginAction = getLogInAPIAction();
        if (action.payload.action === loginAction) {
            return action.payload.response.data.token
                ? action.payload.response.data.token
                : usertoken;
        }
    } else if (action.type === LOAD_USERDATA) {
        if (action.payload !== null) return action.payload.token;
    }
    return usertoken;
};
// Stores the original login token (main account).
// usertokenReducer will later be modified to hold the active account token after switching.
const userMainTokenReducer = (usertoken = "", action) => {

    if (usertoken === undefined || usertoken === null) {
        return "";
    }

    if (action.type === LOGOUT) {
        return "";
    }
    else if (action.type === RECEIVE_SERVER_RESPONSE) {
        if (action.payload.response.status === "error" && action.payload.response.code === 600) {
            return "";
        }

        const loginAction = getLogInAPIAction();
        if (action.payload.action === loginAction) {
            return action.payload.response.data.token ? action.payload.response.data.token : usertoken;
        }
    } else if (action.type === LOAD_USERDATA) {
        if (action.payload !== null)
            return action.payload.token
    }
    return usertoken;
}


const reloadBrandsSignalReducer = (signal = 0, action) => {
    if (action.type === RELOAD_BRANDS) {
        return signal + 1;
    }
    return signal;
};

const activeAccountIdReducer = (activeAccountId = null, action) => {
    if (action.type === LOGOUT) {
        return null;
    }
    if (action.type === SET_ACTIVE_ACCOUNT_ID) {
        return action.payload;
    }
    if (action.type === LOAD_USERDATA) {
        const id = action.payload?.user?.accountid;
        return id != null ? String(id) : activeAccountId;
    }
    if (action.type === RECEIVE_SERVER_RESPONSE) {
        // const id = action.payload?.response?.data?.user?.accountid;
        // if (id != null) return String(id);

        // Only update from the login action's response — not from arbitrary API calls
        const loginAction = getLogInAPIAction();
        if (action.payload?.action === loginAction) {
            const id = action.payload?.response?.data?.user?.accountid;
            if (id != null) return String(id);
        }
    }
    return activeAccountId;
};

const accountsReducer = (accounts = [], action) => {
    if (action.type === LOGOUT) {
        return [];
    }
    if (action.type === LOAD_ACCOUNTS) {
        return action.payload || [];
    }
    return accounts;
};

// ---------------------------------------------------------------------------
// Plan-based access control reducers
// ---------------------------------------------------------------------------

const planDataReducer = (planData = null, action) => {
    if (action.type === LOGOUT) {
        PlanLimitsManager.reset();
        return null;
    }
    if (action.type === LOAD_PLAN_DATA) {
        const newPlan = action.payload || null;
        PlanLimitsManager.init(newPlan, PlanLimitsManager.overrides);
        return newPlan;
    }
    return planData;
};

const planOverridesReducer = (overrides = null, action) => {
    if (action.type === LOGOUT) {
        return null;
    }
    if (action.type === LOAD_PLAN_OVERRIDES) {
        const newOverrides = action.payload || null;
        PlanLimitsManager.init(PlanLimitsManager.planData, newOverrides);
        return newOverrides;
    }
    return overrides;
};

const navHistoryReducer = (navHistory = [], action) => {
    if (action.type === PAGE_SELECTED) {
        if (action.payload.doAddToHistory) {
            navHistory.push(action.payload);
        }
    } else if (action.type === CLEAR_NAV_HISTORY) {
        if (navHistory.length > 0) {
            navHistory = [];
        }
    } else if (action.type === STEP_BACK) {
        if (navHistory.length > 0) {
            var lastPage = navHistory[navHistory.length - 1];
            // if (lastPage.id === PageNames.SURVEYSUMMARY_PAGE) {

            //     while (navHistory.length > 0 && (lastPage.id !== PageNames.EDITSURVEY_PAGE) && (lastPage.id !== PageNames.SEARCHSHOP_PAGE) && (lastPage.id !== PageNames.SEARCHSURROUND_PAGE)) {
            //         navHistory.pop();
            //         lastPage = navHistory[navHistory.length - 1];
            //     }

            //     if (navHistory.length === 0) {
            //         navHistory.push({ id: PageNames.EDITSURVEY_PAGE, content: null, doAddToHistory: true })
            //     }
            // }
            // else {
            navHistory.pop();
            // }

            if (navHistory.length === 0) {
                navHistory.push({
                    id: Constants.DASHBOARD_PAGE,
                    content: null,
                    doAddToHistory: true,
                });
            }
        }
    }

    return navHistory;
};

export default combineReducers({
    usertoken: usertokenReducer,
    usermaintoken: userMainTokenReducer,
    userdata: userdataReducer,
    selectedPage: selectedPageReducer,
    router: routerReducer,
    selectedBrandData: selectedBrandDataReducer,
    selectedBranchData: selectedBranchDataReducer,
    navHistory: navHistoryReducer,
    accounts: accountsReducer,
    activeAccountId: activeAccountIdReducer,
    reloadBrandsSignal: reloadBrandsSignalReducer,
    globalSearch: globalSearchReducer,
    alertMessage: alertMessageReducer,
    planData: planDataReducer,
    planOverrides: planOverridesReducer,
});
